export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7750.3e24e507.jpg";